exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../css-loader/index.js!./element/index.css"), "");
exports.i(require("-!../../../css-loader/index.js!./var.css"), "");
exports.i(require("-!../../../css-loader/index.js!./global.css"), "");
exports.i(require("-!../../../css-loader/index.js!./colors.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader!./node_modules/shopee-theme/dist/shopee/index.css
// module id = 203
// module chunks = 0